/* Cart quantity badge on product cards, resynced on Horizon's cart:update event. */
(function () {
  'use strict';

  var lastCart = null;

  function apply(cart) {
    if (cart) lastCart = cart;
    var qtyByProduct = {};
    var items = (lastCart && lastCart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      qtyByProduct[it.product_id] = (qtyByProduct[it.product_id] || 0) + it.quantity;
    }

    var cards = document.querySelectorAll('.bq-card[data-product-id]');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var badge = card.querySelector('.bq-card__count');
      if (!badge) continue;
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var n = qtyByProduct[pid] || 0;
      if (n > 0) {
        var label = n > 99 ? '99+' : String(n);
        if (badge.textContent !== label || badge.hidden) {
          badge.textContent = label;
          // Restart the bump on each quantity change.
          badge.classList.remove('bq-bump');
          void badge.offsetWidth;
          badge.classList.add('bq-bump');
        }
        badge.hidden = false;
        card.classList.add('has-qty');
      } else {
        badge.hidden = true;
        card.classList.remove('has-qty');
      }
    }
  }

  var refreshSeq = 0;
  function refresh() {
    // No card to badge: no request (article, FAQ, contact…).
    if (!document.querySelector('.bq-card[data-product-id]')) return;
    // Anti-race token: only the last refresh's response applies
    // (two quick adds crossed their fetches, causing stale state).
    var mine = ++refreshSeq;
    fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart && mine === refreshSeq) apply(cart); })
      .catch(function () {});
  }

  // Coalesce the burst (finally + safety net + MutationObserver) into one
  // request. The refreshSeq token still guarantees last-write-wins correctness.
  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshTimer = null; refresh(); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Horizon's actual event: StandardEvents.cartLinesUpdate
  // ('shopify:cart:lines-update'). It is optimistic: dispatched before the
  // POST /cart/add is committed, with the request promise in detail, so
  // an immediate refresh read the stale cart (badge always one step
  // behind).
  function onCartLinesUpdate(event) {
    // The promise rides on the event itself, not on `detail`:
    // `event.detail` is undefined while `event.promise` is the thenable Horizon
    // awaits internally. Reading `detail.promise` always missed, which left the
    // badge riding the blind timers below instead of the commit.
    var p = event && (event.promise || (event.detail && event.detail.promise));
    if (p && typeof p.finally === 'function') {
      p.finally(scheduleRefresh);
    } else {
      setTimeout(scheduleRefresh, 350);
    }
    // Safety net: some paths resolve the promise before the visible commit.
    setTimeout(scheduleRefresh, 1200);
  }
  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);

  // Cards injected after the first scan (predictive search, morphs):
  // reapply the already-known cart, without re-fetch, as soon as a .bq-card enters the DOM.
  var pending = false;
  function scheduleApply() {
    if (pending) return;
    pending = true;
    // Immediate reactivity with the known state, then server truth: each
    // add triggers a morph (header bubble), so this refresh guarantees the badge
    // even if the cart event is lost. Anti-race token in refresh().
    setTimeout(function () {
      pending = false;
      if (lastCart) apply();
      scheduleRefresh();
    }, 0);
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.bq-card') || n.querySelector('.bq-card'))) {
            scheduleApply();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.bqCardCart = { apply: function () { apply(); }, refresh: refresh };
})();
